import { observer } from 'mobx-react';
import BraintreeCredentialsStore from '../../../stores/credentials/braintree-credentials-store';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';

interface IProps {
    credentialsStore: BraintreeCredentialsStore;
    vGroup: IValidationGroup;
}

const BraintreeCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Public Key'
                key='public-key'
                note='Your Braintree Public Key'
            >
                <Input
                    value={credentialsStore.publicKey}
                    onChange={credentialsStore.setPublicKey}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Private Key'
                key='private-key'
                note='Your Braintree Private Key'
            >
                <Input
                    value={credentialsStore.privateKey}
                    onChange={credentialsStore.setPrivateKey}
                    validationGroup={vGroup}
                    type='password'
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default BraintreeCredentials;